import DiTokenManager from '../../auth/DiTokenManager';
import { isModern } from './NavigationUtil';
import { isHarmonyConnect, notifyTokenExpired } from 'utils/harmonyConnectApp/harmonyConnectAppUtil';

export const LOGOUT_URL = isModern() ? '/modern/auth/logout' : '/app/logout';

var AuthenticationUtil = {
    signOut: function() {
        DiTokenManager.removeToken();
        this.toSignOutPage();
    },

    toSignOutPage: function() {
        location.href = LOGOUT_URL;
    },

    toSSOSignin: function() {
        // Clean up current token
        DiTokenManager.removeToken();
        // If the user is on Harmony Connect, notify that the token has expired instead of redirecting to the signin page
        // Harmony connect will handle the expired
        if (isHarmonyConnect()) {
            notifyTokenExpired(window.location.href);
            return;
        }

        // Send user to SSO sign in page to refresh session then redirect back to current page
        const SSO_DOMAIN = new URL(window.GAUTH_HOST).hostname;
        const clientId = location.host === 'connectus.garmin.cn' ? 'GarminConnectUSCN' : 'GarminConnect';
        const serviceURL = location.href;
        const SSO_SIGNIN_URL = `https://${SSO_DOMAIN}/portal/sso/sign-in?clientId=${clientId}&service=${encodeURIComponent(
            serviceURL
        )}`;
        location.replace(SSO_SIGNIN_URL);
    }
};

export default AuthenticationUtil;
